const SET_WORKER = (state, payload) => {
    state.worker = '';
    state.worker = payload;
}
const CLEAR_WORKER = (state) => {
    state.worker = '';
}

const SET_WORKER_LIST = (state, payload) => {
    state.worker_list = [];
    state.worker_list = payload;
}
const CLEAR_WORKER_LIST = (state) => {
    state.worker_list = [];
    state.failed_jobs = '';
    state.pending_jobs = '';
    state.sync_jobs = '';
}

const SET_FAILED_JOBS = (state, payload) => {
    state.failed_jobs = '';
    state.failed_jobs = payload;
}
const CLEAR_FAILED_JOBS = (state) => {
    state.failed_jobs = '';
}

const SET_PENDING_JOBS = (state, payload) => {
    state.pending_jobs = '';
    state.pending_jobs = payload;
}
const CLEAR_PENDING_JOBS = (state) => {
    state.pending_jobs = '';
}

const SET_SYNC_JOBS = (state, payload) => {
    state.sync_jobs = '';
    state.sync_jobs = payload;
}
const CLEAR_SYNC_JOBS = (state) => {
    state.sync_jobs = '';
}

const CLEAR_STATES = (state) => {
    state.worker = '';
    state.worker_list = [];
    state.failed_jobs = '';
    state.pending_jobs = '';
    state.sync_jobs = '';
    state.meta = [];
}

export {
    SET_WORKER,
    CLEAR_WORKER,
    SET_WORKER_LIST,
    CLEAR_WORKER_LIST,
    SET_FAILED_JOBS,
    CLEAR_FAILED_JOBS,
    SET_PENDING_JOBS,
    CLEAR_PENDING_JOBS,
    SET_SYNC_JOBS,
    CLEAR_SYNC_JOBS,
    CLEAR_STATES
}
